<template>
  <div class="afterSalePolicy">
    <div class="afterSalePolicy-content">
      <h2>售后政策：</h2>
      <ul>
        <li>
          <h3>1、退换货定义</h3>
          <div>
            已生效的合同，甲方将不满意的商品退还给乙方或乙方因为第三方不可抗因素造成无法供货并最终取消合同的售后类型称为退货。
          </div>
        </li>
        <li>
          <h3>2、退换货原则</h3>
          <div>
            工自仪所售商品均为全新正品，在商品包装完整、数量准确的前提下，客户下单购买的标准商品（非标准品除外），可根据本规则申请退换货事宜。（注：“包装完整”是指产品外包装没有破损，内件不缺，不影响再次包装或销售）
          </div>
        </li>
        <li>
          <h3>3、退换货注意事项</h3>
          <div>
            <div>
              1）退货商品需要保证保持收到商品时的原貌与原性能，且没有经过使用，不影响二次销售；
            </div>
            <div>2）退货商品的外包装，所属配件等需完好；</div>
            <div>
              3）如果合同已经开票，需要客户将发票及相关证明在约束的时间内退回公司完成作废或红冲处理。
            </div>
          </div>
        </li>
        <li>
          <h3>4、退换货细则及申请说明</h3>
          <div>
            工自仪承诺符合以下情况，可通过【我的订单】在线发起售后，我们会在1个工作日内处理，您也可以联系专属客户经理/客服或拨打 400-887-6000申请办理退换货事宜。
          </div>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column
              prop="type"
              label="退换货类别"
              width="140"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="desc"
              label="具体描述"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="isRefund"
              label="是否支持退货"
              width="120"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="isChange"
              label="是否支持换货"
              width="120"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="isPayBack"
              label="是否收取返回运费"
              width="140"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              header-align="center"
            ></el-table-column>
          </el-table>
          <div class="tip mb-10">
            注：符合退换货标准的商品，如对应商品无库存无法换货时，仅能办理退货或根据需求进行替换。
          </div>
          <div>以下情况，不支持退换货：</div>
          <div>a. 非工自仪销售的商品；</div>
          <div>b. 主商品对应的配件、外包装等被损坏或丢失（货损除外）；</div>
          <div>
            c. 客户提出退换货的原因是公司出具的报价或合同内的产品描述与客户想象的不同，但是我司实际供货无问题的；
          </div>
          <div>d. 定制商品、代购商品；</div>
          <div>e. 一次性用品；</div>
          <div>f. 商品本身性能决定不允许退换货的配件或耗材类商品；</div>
          <div>g. 影响二次销售的产品</div>
        </li>
        <li>
          <h3>5、客户退货、退票</h3>
          <div>
            <div>
              客户协助将涉及退货的商品在要求的时间内退回并完好入库；如果合同已经开票，需要客户将发票及相关证明在约束的时间内退回公司完成作废或红冲处理。
            </div>
            <div>1）退货处理</div>
            <div>
              退回商品完好入库，售后人员通过线上系统同步采购反馈退货流向，采购人员需在一个工作日内回复，我司仓库管理人员根据采购的回复通知仓库入库或退供应商。
            </div>
            <div>2）财务发票处理：</div>
            <div>
              ①
              发票作废：当月开出的发票当月退回发票可以作废，发票可以直接交至财务部申请发票作废。
            </div>
            <div>
              ②
              发票红冲：当月开出的发票隔月退回发票需要红冲，增值税发票处理按以下方式
            </div>
            <div>
              ③
              客户发票未认证，凭增值税发票原件（两联）及对方出具的拒收证明，由财务部财务专员到税务局开具红字通知书，每周红冲一次。
            </div>
            <div>
              ④
              对方已认证的，客户去当地税务局办理《开具红字发票通知书》，当日15点前提交正确红冲申请单，当日可完成红冲处理；当日15点后提交正确红冲申请单，隔日完成。
            </div>
            <div>
              ⑤
              增值税发票退回公司红冲，任何时间开的票都可以冲红。
            </div>
            <div>
              ⑥
              如果发票类型属于普通商品发票，即使隔月退回，可以直接交财务申请红冲处理即可。
            </div>
          </div>
        </li>
        <li>
          <h3>6、退款或转款处理</h3>
          <div>
            <div>
              1）商品入库后且发票正常处理完成后，可为客户申请退款或转款。财务要求退款的账户公司名称必须要与合同公司名称相同，不同需要合同公司提供委托证明，否则不允许申请退款。
            </div>
            <div>2）出现售后问题合同的退款及转款均由售后人员提交财务处理。</div>
            <div>
              3）如果退货性质属于客户单方面违约提出退货，退款时需要扣除违约金部分再退回剩余货款。售后人员需要在扣除违约金前通知到客户，并取得客户的理解。公司可以根据客户的需求，为客户提供合同内约定的同类型发票。
            </div>
            <div>
              4）售后人员提出退款申请后，财务人员根据我司相关的退款条款执行退款。
            </div>
          </div>
        </li>
        <li>
          <h3>7、《退货流程图》</h3>
          <img
            src="https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/policy/afterSalePolicy_01.png"
            alt="退货流程图"
          />
          <div class="tip">
            注：如为质量问题导致的退货、换货、维修，需将附件、说明书、纸质发票、保修卡、包装、商品，一并返回工自仪仓库或厂家（电子发票无需返回）。
          </div>
        </li>
        <li>
          <h3>8、注意事项</h3>
          <div>
            <div>
              1）元器件：属于精密器件，如操作不当极易造成产品损坏，申请退换货之前需买卖双方达成一致，以避免相关损失（因质量问题退换货需出具第三方权威检测机构的报告）。
            </div>
            <div>
              2）公共设施-流体相关-泵：商品特性问题体积和重量较大，可能会产生高额运费，客户原因导致的退换货需要客户自行承担运费，建议客户选型之前仔细确认，必要时请联系销售协助选型；以下几种情形不支持退换货：①水泵已安装 ②定制类水泵 ③ 部分原装进口商品一次包装破损 ④人为因素导致商品破损 ⑤大宗商品订购。
            </div>
            <div>
              3）动力传动-轴承：属于工业半成品，原材料为钢的轴承，如包装完好、数目准确、不影响二次销售的，支持退换货；陶瓷轴承、塑料轴承、磁悬浮轴承以及其他非标定制轴承等不支持无理由退换货。
            </div>
            <div>
              4）需要安装的商品，因安装后存在不可恢复的安装痕迹，影响商品完好，一经安装后非质量问题不支持退换货；工业防护服装类商品，吊牌标识被摘或水洗后非质量问题不支持退换货。
            </div>
            <div>
              5）商品包装（含主要部件的独立包装）建议在收货之日起至少保留15天，退货时产品包装及每个配件的独立包装需保留（如有遥控器的灯具，退货时需退回遥控器）。
            </div>
            <div>
              6）因个人原因自行拆卸、不正当安装及非正常情况/环境下使用造成的商品损坏，不属于质量问题，不支持退换货。
            </div>
            <div>
              7）退货时赠品需一并返回，如赠品缺失，则主商品无法全额退款（换货无需返回）。
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tableData: [
        {
          type: '商品质量问题',
          desc: '经由品牌商认可的售后服务中心或国家认可的第三方质检平台检测确认的商品问题，并出具有效检测凭证',
          isRefund: '是',
          isChange: '是',
          isPayBack: '否',
          remark:
            '提供有效的质检凭证。非正常使用、保管或自然损耗、意外事件 /不可抗力事件导致损毁、灭失或变质的商品不属于此种情形'
        },
        {
          type: '商品破损、少件',
          desc: '签收时收到商品存在外观变形、损伤、少件等情况。 (少件指缺失主件或配件)',
          isRefund: '是',
          isChange: '是',
          isPayBack: '否',
          remark:
            '需提供第三方物流有效凭证（证明签收货物时商品 即存在破损、少件等情况）'
        },
        {
          type: '货不对版',
          desc: '客户原始想要购买的商品为A，但是实际发送的商品为A-，导致商品不一致',
          isRefund: '是',
          isChange: '是',
          isPayBack: '否',
          remark: '收到商品实物与订单商品的对比图片'
        },
        {
          type: '发错货',
          desc: '供应商或者仓库发错了货，客户实际需要的是A，发送过去的实物是B。',
          isRefund: '是',
          isChange: '是',
          isPayBack: '是',
          remark: '收到商品实物与订单商品的对比图片'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.afterSalePolicy {
  .afterSalePolicy-content {
    width: 1200px;
    margin: 0 auto;
    padding: 30px;
    h3 {
      margin-top: 20px;
    }
    li {
      margin-bottom: 10px;
      div {
        margin-bottom: 8px;
      }
      .tip {
        font-size: 12px;
        color: #666;
      }
    }
  }
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
